import React from "react";
import Link from "components/link";
import SearchSuggestions from "../suggestions";
import getProductUrl from "utils/product-url";
import ProductImages from "components/product/images";
import Money from "components/money";
import OkendoStarRating from "components/okendo/star-rating";
import { trackSelectItem } from "analytics";
import { useCustomer, useSettings } from "hooks/useStore";
import HighlightMatch from "components/highlight-match";
import clsx from "clsx/lite";

const ResultsLink = ({ to, label, trackingClass, onClick }) => (
	<Link to={to} onClick={onClick}
		className={clsx(
			"flex self-center text-sm border-[3px] border-black px-12 py-5 mt-6 font-black tracking-widest",
			trackingClass
		)}
	>
		{label}
	</Link>
);

const ProductItem = ({ product, index, query }) => {
	const { toggleSearch, isSearchOpen } = useSettings(["toggleSearch", "isSearchOpen"]);
	const customer = useCustomer();
	const { title, type } = product;


	const handleProductClick = (e) => {
		e.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
		if (isSearchOpen) toggleSearch();
	};

	return (
		<Link to={getProductUrl(product)} onClick={handleProductClick}
			onKeyDown={(e) => e.key === "Enter" && handleProductClick(e)}
			className="search-product-item t-search-product-click group/card"
			tabIndex={0} aria-label={`View ${title}`}
		>
			<div className="flex gap-2.5">
				<ProductImages product={product} />
				<div className="w-full">
					<div className="flex flex-col justify-around h-full">
						<div>
							<OkendoStarRating reviewAggregate={product?.reviewAggregate}
								className="flex" starsWidth="w-16" />
							<h5 className="text-start line-clamp-2 text-base mb-auto py-0.5">
								{title}
							</h5>
							<p className="search-product-type">
								<HighlightMatch text={type} query={query} />
							</p>
							{!title?.toLowerCase().includes(query?.toLowerCase()) &&
								<p className="search-product-type t39c">
									<HighlightMatch text={type} query={query} />
								</p>
							}
						</div>
						<p className="font-semibold text-xs flex">
							<Money value={product.minVariantPrice} markets={product.variant?.markets} />
						</p>
					</div>
				</div>
			</div>
		</Link>
	);
};

const DesktopResults = ({ results, products, query, popularTerms, collection, handleClick }) => (
	<>
		<SearchSuggestions popularTerms={popularTerms} results={query ? results.terms : null} query={query} />
		<div className="flex flex-col mt-0 flex-nowrap w-full gap-4">
			{!query && <span className="text-secondary">Best Sellers</span>}
			<div className="flex flex-row gap-x-6 gap-y-8 flex-wrap justify-center">
				<div className="products-search-results ">
					{products.slice(0, 6).map((product, index) => (
						<ProductItem key={index} product={product} index={index} query={query} />
					))}
				</div>
			</div>
		</div>
		{
			query && !collection && (
				<ResultsLink to={`/search?q=${query}`} label="VIEW ALL RESULTS"
					trackingClass="t-search-all-results-click" onClick={handleClick}
				/>
			)
		}
		{
			query && collection && (
				<ResultsLink to={`/collections/${collection.handle}`}
					label={`SHOP ALL ${collection.searchLabel.toUpperCase()}`}
					trackingClass="t-search-collection-click" onClick={handleClick}
				/>
			)
		}
	</>
);

export default DesktopResults;
